export default __webpack_public_path__ + "static/media/img_21.5227773c.JPG";